module.exports = __webpack_public_path__ + "static/media/22.1c3da22a.jpeg";